var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.downloadContract(_vm.item)}}},[_c('v-icon',[_vm._v("mdi-download-circle")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }